import React, {Component} from 'react'
import CPageNew from '@/components/CPageNew'
import CBaseComponent from '@/components/CBaseComponent'
import { goodsManageListNewData} from './data'
import { addusers} from "@/servers/goodsManageApi";
import { getStoreList} from "@/servers/storeManageApi";
import {setPageNewItem, setPageNewValue, urlFormat} from "@/utils";
import _ from 'lodash'
import './index.scss'
import {dpeallcitylist} from "../../../../utils/citylist";
import {message, Modal} from "antd";
import {compose} from "redux";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";

@CBaseComponent
class StoreManageListNew extends Component{

  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }


  state = {
    data: goodsManageListNewData
  }

  onChange(data){
    this.setState({
      data: setPageNewItem(this.state.data, data.data.id, 'value', data.value)
    })
  }

  onCancel(){
    this.props.history.push({
      pathname: '/informationDeclaration/museumperson'
    })
  }

  onSearch(data){

  }


  onSubmit(data){
    let method = null;
    if(this.props.history!==undefined &&  urlFormat(this.props.history.location.search).query.type === 'edit'){
      data.data.id = urlFormat(this.props.history.location.search).query.id;
      method = addusers;
    }else{
      method = addusers
    }
    data.data.levelids = data.data.levelids.join(',')
    if(this.getUrlParams(window.location.href).type === 'edit'){
      data.data.id = this.getUrlParams(window.location.href).id
    }
    method(data.data).then(res=>{
      if (res.statecode === 0) {
        this.setState({

        })
        if(this.getUrlParams(window.location.href).type === 'edit'){
          message.success('编辑成功');
        }
        else {
          message.success('添加成功');
        }
        this.props.history.push({
          pathname: '/informationDeclaration/museumperson',
        })
      } else {
        if(this.getUrlParams(window.location.href).type === 'edit'){
          message.error('编辑失败');
        }
        else {
          message.error('添加失败');
        }
      }
    }).catch(err=>{

    });
  }


  getUrlParams(url) {
    // 通过 ? 分割获取后面的参数字符串
    let urlStr = url.split('?')[1]
    // 创建空对象存储参数
    let obj = {};
    // 再通过 & 将每一个参数单独分割出来
    let paramsArr = urlStr.split('&')
    for(let i = 0,len = paramsArr.length;i < len;i++){
      // 再通过 = 将每一个参数分割为 key:value 的形式
      let arr = paramsArr[i].split('=')
      obj[arr[0]] = arr[1];
    }
    return obj
  }

  componentWillMount(){
    goodsManageListNewData[0].data[3].options = dpeallcitylist
    if(this.getUrlParams(window.location.href).type === 'edit'){
      let params = this.state.data
      const edit = JSON.parse(sessionStorage.getItem('userEdit'))
      params[0].data[0].value = edit.title
      params[0].data[1].value = edit.levelids
      params[0].data[2].value = edit.indicatorids
      params[0].data[3].value = edit.provinceids
      params[0].title = '编辑博物馆专家组'
      this.setState({
        data:params
      })
    } else {
      let params = this.state.data
      params[0].data[0].value = ''
      params[0].data[1].value = ''
      params[0].data[2].value = ''
      params[0].data[3].value = ''
    }
  }

  render(){
    return (
      <div className='store-manage-list-new' id='top'>
        <CPageNew data={this.state.data}
                  onChange={this.onChange}
                  onSearch={this.onSearch}
                  onSubmit={this.onSubmit}
                  onCancel={this.onCancel}
        />
      </div>
    )
  }
}
export default compose(withRouter)(StoreManageListNew);
